import styled, { css } from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { media, rem, themed } from '@/shared/ui/core';
import { Label } from '@/shared/ui/elements';

export const ShiftStyled = styled.details.attrs({
  className: 'ShiftStyled',
})`
  width: 100%;
  display: block;
  pointer-events: ${({ isDisabled }) => isDisabled ? 'none' : 'initial'};

  .Tag {
    margin-top: 0.75rem;

    span {
      font-size: 0.75rem;
      line-height: 1.25;
      text-transform: initial;
    }
  }

  a.component__link {
    color: inherit;
    text-decoration: underline;
  }

  @media ${media.tabletMin} {
    > span {
      max-width: 57.5rem;
      text-transform: none;
      margin-top: 0.75rem;
    }
  }
`;

export const SuccessNofication = styled.div`
  border-radius: 0.375rem;
  margin: -1rem 0;
  margin-left: -0.75rem;
  width: calc(100% + (0.75rem * 2));

  .InfoNotice {
    padding: .5rem .625rem;

    .IconContainer {
      border: 1px solid ${themed('primary.main')};
      padding: .5rem;

      svg {
        width: 1rem;
      }
    }
  }
`;

export const ShiftContainer = styled.div.attrs({
  className: 'ShiftContainer',
})`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  opacity: 1;

  ${({ isDisabled }) => isDisabled && css`
    opacity: 0.25;
    pointer-events: none;
  `};

  ${({ isColumnDirection }) => isColumnDirection
    && css`
      @media ${media.tabletMin} {
        flex-direction: row;
      }
    `}
`;

export const ShiftInfoWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 50%;
`;

export const ShiftActions = styled.div.attrs({
  className: 'ShiftActions',
})`
  align-items: flex-start;
  display: flex;
  flex: 1;
  justify-content: flex-end;
  max-width: 100%;
  order: 2;
  width: 100%;

  form {
    width: 100%;

    div {
      align-items: center;
      display: flex;
      gap: 1rem;
      justify-content: space-between;
      width: 100%;
    }

    label.component__Checkbox {
      color: ${themed('primary.main')};
      font-size: 0.825rem;
      font-weight: bold;
      line-height: 1.0625rem;
      margin-top: 0.625rem;
    }
  }

  .ErrorNotice {
    margin-top: 0;
  }

  @media ${media.tabletMin} {
    margin-top: 0;
    order: unset;

    .ErrorNotice {
      margin-top: 1rem;
    }
  }

  ${({ showBuyItNow }) => showBuyItNow
    && css`
      margin-top: 0.625rem;
      order: unset;

      @media (min-width: 23.4375rem) {
        min-width: 18.75rem;
      }
    `}
`;

export const BuyItNow = styled.div.attrs({
  className: 'BuyItNow',
})`
  flex: 1;

  div {
    align-items: center;
    display: flex;

    button {
      align-items: center;
      display: flex;
      font-size: 0.875rem;
      justify-content: space-between;
      line-height: 1.125rem;
      padding: 0 0.625rem;
      max-width: 9.6875rem;

      span {
        font-weight: normal;
      }

      @media ${media.tabletMin} {
        margin-top: 0.5rem;
      }
    }

    .Text {
      color: ${themed('primary.textGray')};
      font-size: 0.75rem;
      line-height: 0.875rem;
      letter-spacing: 0.25px;
      margin: auto;

      @media ${media.tabletMin} {
        margin: 0.5rem auto 0;
      }
    }

    & + .Text {
      color: ${themed('primary.darkGray')};
      display: block;
      font-size: 0.75rem;
      letter-spacing: 0.25px;
      line-height: 0.875rem;
      margin-top: 0.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }

    & + .Text.tokens-left {
      color: ${themed('primary.text')};
      font-weight: 500;
    }
  }
`;

export const BidsInfo = styled.div.attrs({
  className: 'BidsInfo',
})`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;

  .Text {
    color: ${themed('primary.darkGray')};
    font-size: 0.75rem;
    letter-spacing: 0.25px;
    line-height: 0.875rem;
    margin-top: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
`;

export const ShiftInfo = styled.div.attrs({
  className: 'ShiftInfo',
})`
  display: block;
  flex: 1;
  overflow: hidden;
  padding-right: 1rem;
  cursor: pointer;

  .Title {
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.15px;
    color: ${themed('primary.accent')};
  }

  .Text {
    font-size: 0.875rem;
    letter-spacing: 0.25px;
    color: ${themed('primary.darkGray')};
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .LabelWrapper {
    margin-bottom: 0.5rem;
    .Text {
      font-size: 0.875rem;
      color: ${themed('primary.text')};
    }
    .ShiftLabelStyled {
      .Text {
        font-size: 0.75rem;
        color: ${themed('primary.text')};
      }
    }
  }

  @media ${media.tabletMin} {
    .Title {
      font-size: 1.125rem;
    }
  }
`;

export const ShiftTime = styled.div.attrs({
  className: 'ShiftTime',
})`
  .Text {
    font-size: 0.875rem;
    letter-spacing: 0.25px;
    color: ${themed('primary.darkGray')};
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: ${({ hourLineThrough }) => hourLineThrough ? 'line-through' : ' none'};
  }

  .LabelWrapper {
    margin-bottom: 0.5rem;
    .Text {
      font-size: 0.875rem;
      color: ${themed('primary.text')};
    }
    .ShiftLabelStyled {
      .Text {
        font-size: 0.75rem;
        color: ${themed('primary.text')};
      }
    }
  }
`;

const bidModifiers = {
  approved: ({ theme }) => ({
    styles: `
      border-color: ${theme.primary.accent};
      .Text {
        color: ${theme.primary.accent};
      }
    `,
  }),
  canceled: ({ theme }) => ({
    styles: `
      border-color: ${theme.primary.darkGray}90;
      .Text {
        color: ${theme.primary.darkGray}90;
      }
    `,
  }),
  withdrawn: ({ theme }) => ({
    styles: `
      border-color: ${theme.primary.darkGray}90;
      .Text {
        color: ${theme.primary.darkGray}90;
      }
    `,
  }),
  declined: ({ theme }) => ({
    styles: `
      border-color: ${theme.primary.darkGray}90;
      .Text {
        color: ${theme.primary.darkGray}90;
      }
    `,
  }),
  in_review: ({ theme }) => ({
    styles: `
      border-color: ${theme.primary.darkGray}DD;
      .Text {
        color: ${theme.primary.darkGray}DD;
      }
    `,
  }),
};

export const BidAmount = styled.div.attrs({
  className: 'BidAmount',
})`
  width: 4.25rem;
  min-width: 4.25rem;
  height: 2.5rem;
  border: ${rem(1)} solid ${themed('primary.darkGray')};
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .Text {
    color: ${themed('primary.darkGray')};
    font-size: 1.125rem;
    font-weight: 600;
    display: block;
  }

  ${applyStyleModifiers(bidModifiers)};
`;

export const ExtraInfo = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;

  > .Text {
    color: ${themed('primary.darkGray')}99;
    font-size: 0.75rem;
    line-height: 1.35;
    margin-top: 0.5rem;
    max-width: 5.75rem;
    min-width: 5.75rem;
    text-align: center;
  }
`;

export const WarningTag = styled.div`
  align-items: center;
  background-color: ${themed('status.warning.light')};
  color: ${themed('primary.darkGray')};
  display: inline-flex;
  font-size: 0.75rem;
  line-height: 1.35;
  margin-top: 1rem;
  padding: 0.5rem;

  svg {
    fill: ${themed('status.warning.main')};
    margin-right: 0.5rem;
    max-width: 1rem;
    min-width: 1rem;
  }
`;

export const ShiftHeader = styled.div.attrs({
  className: 'ShiftHeader',
})`
  margin-top: 0.75rem;
  display: flex;
  align-items: center;
  flex-direction: row;

  .Text {
    font-size: 0.875rem;
    color: ${themed('primary.text')};
    margin-bottom: 0.25rem;
  }
`;

export const ShiftName = styled.div.attrs({
  className: 'ShiftName',
})`
  display: flex;
  align-items: center;
  flex-direction: row;

  .Title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ShiftListHeader = styled.summary.attrs({
  className: 'ShiftListHeader',
})`
  @media (min-width: 360px) {
    .ShiftContainer {
      min-height: 2.25rem;
    }
  }

  .component__Checkbox {
    position: relative;
    top: 2px;
  }
`;

export const ShiftLabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`;

export const ShiftDetailHeader = styled.summary.attrs({
  className: 'ShiftDetailHeader',
})`
  .ShiftHeader {
    justify-content: space-between;

    .Title {
      font-size: 1.125rem;
      color: ${themed('primary.accent')};
      padding-right: 0.5rem;
    }

    .component__label {
      text-align: right;
    }
  }

  .ShiftContainer {
    margin-top: 1.5rem;

    .ShiftInfo {
      .Text {
        font-size: 1rem;

        &:first-of-type {
          color: ${themed('primary.text')};
          display: flex;
          margin-bottom: 0.25rem;
        }
      }
    }

    .BidAmount {
      width: 5rem;
      min-width: 5rem;
      height: 3rem;

      .Text {
        font-size: 1.375rem;
        font-weight: 700;
      }
    }
  }

  .ShiftLabelStyled {
    margin-bottom: 0.5rem;
  }

  .PillLabelWrapper {
    margin-top: -0.25rem;
  }
`;

export const BidWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
`;

const statusModifiers = {
  canceled: ({ theme }) => ({
    styles: `
      &::before {
        background-color: ${theme.states.declined};
      }
    `,
  }),
  withdrawn: ({ theme }) => ({
    styles: `
      &::before {
        background-color: ${theme.states.declined};
      }
    `,
  }),
  declined: ({ theme }) => ({
    styles: `
      &::before {
        background-color: ${theme.states.declined};
      }
    `,
  }),
  approved: ({ theme }) => ({
    styles: `
      &::before {
        background-color: ${theme.states.approved};
      }
    `,
  }),
  in_review: ({ theme }) => ({
    styles: `
      &::before {
        background-color: ${theme.states.pending};
      }
    `,
  }),
  shiftDetails: () => ({
    styles: `
      margin: 0 0 0.5rem;
    `,
  }),
};

export const StatusLabel = styled(Label)`
  font-size: 0.75rem;
  font-weight: 600;
  padding-left: 0.75rem;
  border-radius: 0.25rem;
  margin: 0;
  color: ${themed('primary.text')};
  position: relative;

  &::before {
    content: '';
    height: ${rem(7)};
    width: ${rem(7)};
    border-radius: 50%;
    background-color: ${themed('primary.text')};

    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-75%);
  }

  + div {
    margin-top: 0.25rem;
  }

  ${applyStyleModifiers(statusModifiers)};
`;

export const PillLabelWrapper = styled.div.attrs({
  className: 'PillLabelWrapper',
})`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  min-height: ${({ forceSpace }) => forceSpace ? rem(20) : 0};
  padding-right: 0.5rem;

  .PillLabelStyled {
    margin-right: 0.5rem;
    margin-top: 0.5rem;

    .Text {
      font-size: 0.75rem;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const ShiftItemContent = styled.div`
  ${({ displayShift }) => displayShift
    && css`
    padding: 1rem 0.75rem;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0.375rem;
    border: 1px solid ${themed('common.borderColor')}40;
    background-color: ${themed('primary.background')};
    `}
`;

export const HalfDayNotice = styled.div.attrs({
  className: 'HalfDayNotice',
})`
  width: 100%;
  border-radius: 4px;
  background-color: #FDFBE8;
  color: ${themed('primary.main')};
  padding: 1rem;
  font-size: 0.875rem;
`;

export const NoticeWrapper = styled.div`
  max-width: 34.75rem;
  margin-top: 8px;
`;
